export const getYears = (anio: number): number[] => {
    const anoActual = new Date().getFullYear(); // Año actual
    const anios: number[] = [];

    // Luego agregamos el año ingresado y los intermedios hasta el año actual anterior
    for (let i = anoActual; i >= anio; i--) {
        anios.push(i);
    }

    return anios;
};
